/*
 *
 * UserManagement constants
 *
 */

export const DEFAULT_ACTION = "app/UserManagement/DEFAULT_ACTION"

export const GET_USERS_WATCHER = "app/UserManagement/GET_USERS_WATCHER"
export const GET_USERS_SUCCESS = "app/UserManagement/GET_USERS_SUCCESS"
export const GET_USERS_FAILED = "app/UserManagement/GET_USERS_FAILED"

export const UPDATE_INFO_USER = "app/UserManagement/UPDATE_INFO_USER"

export const DELETE_USER_WATCHER = "app/UserManagement/DELETE_USER_WATCHER"
export const DELETE_USER_SUCCESS = "app/UserManagement/DELETE_USER_SUCCESS"
export const DELETE_USER_FAILED = "app/UserManagement/DELETE_USER_FAILED"

export const SWITCH_USER_WATCHER = "app/UserManagement/SWITCH_USER_WATCHER"
export const SWITCH_USER_SUCCESS = "app/UserManagement/SWITCH_USER_SUCCESS"
export const SWITCH_USER_FAILED = "app/UserManagement/SWITCH_USER_FAILED"
